/* eslint-disable react/destructuring-assignment */
/* eslint-disable unicorn/no-null */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-extraneous-dependencies */
// import '@/i18next';
import { Suspense } from 'react';

import Loader from '@/components/Loader';
import './index.css';

type WrapperProperties = {
  children: React.ReactNode;
};

export default function Wrapper(properties: WrapperProperties) {
  return <Suspense fallback={<Loader />}>{properties.children}</Suspense>;
}
